import 'css-vars-ponyfill';
import 'bootstrap-sass';
import './offcanvas.js';
import './smooth-scroll.js';
import './slideshow.js';
import './events.js';
import './parallax.js';
import './past-events.js';

const watchForHover = () => {
  const container = document.body;
  let hasHoverClass = false;
  let lastTouchTime = 0;

  const enableHover = () => {
    // filter emulated events coming from touch events
    if (new Date() - lastTouchTime < 500) return;
    if (hasHoverClass) return;

    container.className += ' no-touch';
    hasHoverClass = true;
  };

  const disableHover = () => {
    if (!hasHoverClass) return;

    container.className = container.className.replace(' no-touch', '');
    hasHoverClass = false;
  };

  const updateLastTouchTime = () => {
    lastTouchTime = new Date();
  };

  document.addEventListener('touchstart', updateLastTouchTime, true);
  document.addEventListener('touchstart', disableHover, true);
  document.addEventListener('mousemove', enableHover, true);

  enableHover();
};

watchForHover();
